import { useContext, useEffect, useRef, useState } from 'react';
import { PublicClientApplication, EventType, AccountInfo, AuthenticationResult, } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from '../../utils/helpers/authConfig';

const MicrosoftProvider = ({ children }) => {

    const msalInstance = new PublicClientApplication(msalConfig);
    const activeAccount = msalInstance.getActiveAccount();
    const allAccounts = msalInstance.getAllAccounts();

    if (!activeAccount && allAccounts.length > 0) {
        // Asegúrate de que allAccounts no esté vacío antes de acceder al índice 0
        msalInstance.setActiveAccount(allAccounts[0] ?? []);
    }

    msalInstance.addEventCallback((event) => {
        const authenticationResult = event.payload as AuthenticationResult;
        const account = authenticationResult?.account;
        if (event.eventType === EventType.LOGIN_SUCCESS && account) {
            msalInstance.setActiveAccount(account);
            // console.log("ACCOUNT", account);
        }
        if (event.eventType === EventType.LOGIN_FAILURE && account) {
            console.log("No se puede iniciar sesión.");
            // console.log("ACCOUNT", account);
        }
    });

    return (
        <MsalProvider instance={msalInstance}>
            {children}
        </MsalProvider>
    );
}

export {
    MicrosoftProvider
};